import 'react-perfect-scrollbar/dist/css/styles.css';
import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from '@material-ui/core';
import { ThemeProvider as StyledThemeProvider } from 'styled-components';
import { styledTheme } from './styles/StyledTheme';

import GlobalStyles from './styles/GlobalStyles';
import defaultTheme from './styles/theme';
import Routes from './routes';
import AppProvider from './hooks';

const App: React.FC = () => {
  return (
    <BrowserRouter>
      <StyledThemeProvider theme={styledTheme}>
        <ThemeProvider theme={defaultTheme}>
          <AppProvider>
            <Routes />
          </AppProvider>

          <GlobalStyles />
        </ThemeProvider>
      </StyledThemeProvider>
    </BrowserRouter>
  );
};

export default App;
